// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/scroll-to-top';
import { StyledChart } from './components/chart';
import ChatBox from './sections/@dashboard/chatbot/ChatBox';


// ----------------------------------------------------------------------

export default function App() {
  return (
    <ThemeProvider>
      <ScrollToTop />
      <StyledChart />
      {console.log("version : 2.0")}
      {/* <ChatBox/> */}
      <Router />
      

    </ThemeProvider>
  );
}
